function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import EBPropTypes from 'js-utils/prop-types';
import gettext from 'js-utils/gettext';
import isEmpty from 'lodash/isEmpty';
import { ITEMS_PROP_TYPE, BREAKDOWN_ITEMS_PROP_TYPE } from './constants';
import Divider from '../divider/Divider';
import Button from '../button/Button';
import ExpansionPanel from '../expansionPanel/ExpansionPanel';
import Icon from '../icon/Icon';
import withTooltip from '../tooltip/withTooltip';
import InfoChunkySvg from '../iconography/icons/InfoChunky';

var TitleContainer = function TitleContainer(_ref) {
  var title = _ref.title,
      actionText = _ref.actionText,
      onClickActionText = _ref.onClickActionText;
  var titleContainer = null;
  var clickableText = null;

  if (actionText && onClickActionText) {
    clickableText = React.createElement("div", {
      className: "eds-g-cell eds-g-cell-6-12 eds-text--right eds-text-bs--fixed eds-text-color--ui-blue",
      role: "gridcell"
    }, React.createElement(Button, {
      style: "none",
      onClick: onClickActionText
    }, actionText));
  }

  if (title) {
    titleContainer = React.createElement("div", null, React.createElement("div", {
      className: "eds-l-mar-bot-6"
    }, React.createElement("div", {
      className: "eds-order-summary-title eds-g-cell eds-g-cell-12-12 eds-text-bm--fixed eds-text-color--grey-900",
      role: "gridcell"
    }, title), clickableText));
  }

  return titleContainer;
};

var ItemsContainer = function ItemsContainer(_ref2) {
  var items = _ref2.items;
  var itemsContainer = null;

  if (items) {
    var rows = items.map(function (_ref3) {
      var content = _ref3.content,
          subcontent = _ref3.subcontent,
          value = _ref3.value,
          quantity = _ref3.quantity,
          color = _ref3.color,
          id = _ref3.id,
          donation = _ref3.donation;
      var className = classNames('eds-g-group', 'eds-l-mar-vert-4', "eds-text-color--".concat(color || 'grey-700'));
      var itemText;

      if (donation) {
        itemText = content;
      } else {
        // Translators: This is the number of items times the item name. Example: 8 x Free Ticket or 2 x Teddy Bears
        itemText = gettext('%(quantity)s x %(content)s', {
          quantity: quantity,
          content: content
        });
      }

      var subcontentContainer;

      if (subcontent) {
        subcontentContainer = React.createElement("p", {
          className: "eds-text-color--grey-600 eds-text-bs--fixed eds-l-mar-top-1"
        }, subcontent);
      }

      return React.createElement("div", {
        className: className,
        key: id,
        role: "row"
      }, React.createElement("div", {
        className: "eds-g-cell eds-g-cell-6-12",
        role: "gridcell"
      }, React.createElement("span", {
        className: "eds-text-bm--fixed eds-text-color--grey-800"
      }, itemText), subcontentContainer), React.createElement("div", {
        className: "eds-g-cell eds-g-cell-6-12 eds-text--right",
        role: "gridcell"
      }, React.createElement("span", {
        className: "eds-text-bm--fixed eds-text-color--grey-800"
      }, value)));
    });
    itemsContainer = React.createElement("div", null, rows);
  }

  return itemsContainer;
};

var BreakdownItemsContainer = function BreakdownItemsContainer(_ref4) {
  var breakdownItems = _ref4.breakdownItems;
  var breakdownItemsContainer = null;

  if (breakdownItems) {
    var rows = breakdownItems.map(function (_ref5, index) {
      var content = _ref5.content,
          subcontent = _ref5.subcontent,
          value = _ref5.value,
          color = _ref5.color,
          id = _ref5.id,
          expansionContent = _ref5.expansionContent,
          infoTooltipContent = _ref5.infoTooltipContent,
          valueAdditionalClassNames = _ref5.valueAdditionalClassNames;
      var isFirstItem = index === 0;
      var className = classNames('eds-g-group', "eds-text-color--".concat(color || 'grey-600'), {
        'eds-l-mar-top-4': isFirstItem,
        'eds-l-mar-top-3': !isFirstItem
      });
      var subcontentContainer;
      var infoTooltipContainer;

      if (subcontent) {
        subcontentContainer = React.createElement("p", {
          className: "eds-text-color--grey-600 eds-text-bs--fixed"
        }, subcontent);
      }

      if (expansionContent) {
        var expandedContent = expansionContent.map(function (item) {
          return React.createElement("div", {
            className: "eds-l-mar-bot-1",
            key: item.id,
            role: "row"
          }, React.createElement("div", {
            className: "eds-g-cell eds-g-cell-6-12",
            role: "gridcell"
          }, React.createElement("span", {
            className: "eds-text-bm eds-text-color--grey-600"
          }, item.content)), React.createElement("div", {
            className: "eds-g-cell eds-g-cell-6-12 eds-text--right",
            role: "gridcell"
          }, React.createElement("span", {
            className: "eds-text-bm eds-text-color--grey-600"
          }, item.value)));
        });
        return React.createElement("div", {
          key: id
        }, React.createElement(ExpansionPanel, {
          linkText: content,
          verticalMargin: "both",
          style: "order-summary",
          suffix: value
        }, expandedContent));
      }

      if (infoTooltipContent) {
        var IconWithTooltip = withTooltip(Icon);
        infoTooltipContainer = React.createElement(IconWithTooltip, {
          type: React.createElement(InfoChunkySvg, null),
          size: "xsmall",
          tooltipId: "tooltip-info",
          tooltipStyle: "basic",
          tooltipText: infoTooltipContent,
          tooltipArrowLocation: "left",
          wrapperComponent: "span"
        });
      }

      var valueTextClasses = classNames('eds-text-bm--fixed', _defineProperty({}, valueAdditionalClassNames, valueAdditionalClassNames));
      return React.createElement("div", {
        className: className,
        key: id,
        role: "row"
      }, React.createElement("div", {
        className: "eds-g-cell eds-g-cell-6-12",
        role: "gridcell"
      }, React.createElement("span", {
        className: "eds-text-bm--fixed"
      }, content, infoTooltipContainer), subcontentContainer), React.createElement("div", {
        className: "eds-g-cell eds-g-cell-6-12 eds-text--right",
        role: "gridcell"
      }, React.createElement("span", {
        className: valueTextClasses
      }, value)));
    });
    var breakdownDivider = null;

    if (!isEmpty(rows)) {
      breakdownDivider = React.createElement("div", {
        className: "eds-l-mar-top-4"
      }, React.createElement(Divider, null));
    }

    breakdownItemsContainer = React.createElement("div", null, rows, breakdownDivider);
  }

  return breakdownItemsContainer;
};

var TotalContainer = function TotalContainer(_ref6) {
  var content = _ref6.content,
      value = _ref6.value,
      currency = _ref6.currency,
      footer = _ref6.footer;
  var totalContainer = null;
  var footerContainer = null;

  if (footer) {
    footerContainer = React.createElement("div", {
      className: "eds-g-cell eds-g-cell-12-12 eds-text--right",
      role: "gridcell"
    }, React.createElement("span", {
      className: "eds-text-bs--fixed eds-text-color--ui-500"
    }, footer));
  }

  if (content && value) {
    totalContainer = React.createElement("div", {
      className: "eds-g-group eds-l-mar-vert-4",
      role: "row"
    }, React.createElement("div", {
      className: "eds-g-cell eds-g-cell-6-12",
      role: "gridcell"
    }, React.createElement("span", {
      className: "eds-text-weight--heavy eds-text-bl--fixed eds-text-color--ui-800"
    }, content)), React.createElement("div", {
      className: "eds-g-cell eds-g-cell-6-12 eds-text--right",
      role: "gridcell"
    }, React.createElement("span", {
      className: "eds-text-bm--fixed"
    }, React.createElement("span", {
      className: "eds-text--uppercase eds-text-color--ui-600"
    }, currency), "\xA0", React.createElement("span", {
      className: "eds-text-weight--heavy eds-text-bl--fixed eds-text-color--ui-800"
    }, value))), footerContainer);
  }

  return totalContainer;
};

var MessageContainer = function MessageContainer(_ref7) {
  var messageContent = _ref7.messageContent;
  var messageContainer = null;

  if (messageContent) {
    messageContainer = React.createElement("div", {
      className: "eds-g-cell eds-l-mar-top-3 eds-g-cell-12-12 eds-text--left",
      role: "gridcell"
    }, React.createElement("span", {
      className: "eds-text-bs--fixed eds-text-color--grey-800"
    }, messageContent));
  }

  return messageContainer;
};

var OrderSummary =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(OrderSummary, _PureComponent);

  function OrderSummary() {
    _classCallCheck(this, OrderSummary);

    return _possibleConstructorReturn(this, _getPrototypeOf(OrderSummary).apply(this, arguments));
  }

  _createClass(OrderSummary, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          items = _this$props.items,
          breakdownItems = _this$props.breakdownItems,
          currency = _this$props.currency,
          totalContent = _this$props.totalContent,
          totalValue = _this$props.totalValue,
          title = _this$props.title,
          breakdownTitle = _this$props.breakdownTitle,
          messageContent = _this$props.messageContent,
          actionText = _this$props.actionText,
          totalCostInfo = _this$props.totalCostInfo,
          onClickActionText = _this$props.onClickActionText;
      var breakdownTitleContainer;

      if (breakdownTitle) {
        breakdownTitleContainer = React.createElement("div", {
          className: "eds-order-summary-breakdown-title eds-l-mar-top-6 eds-l-mar-bot-2 eds-text-bm--fixed"
        }, breakdownTitle);
      }

      return React.createElement("div", {
        className: "eds-order-summary eds-text-bs--fixed",
        role: "grid"
      }, React.createElement(TitleContainer, {
        title: title,
        actionText: actionText,
        onClickActionText: onClickActionText
      }), React.createElement(ItemsContainer, {
        items: items
      }), breakdownTitleContainer, React.createElement(Divider, null), React.createElement(BreakdownItemsContainer, {
        breakdownItems: breakdownItems
      }), React.createElement(TotalContainer, {
        content: totalContent,
        value: totalValue,
        currency: currency,
        footer: totalCostInfo
      }), React.createElement(MessageContainer, {
        messageContent: messageContent
      }));
    }
  }]);

  return OrderSummary;
}(PureComponent);

_defineProperty(OrderSummary, "propTypes", {
  /**
   * Array of items (such as ticket types)
   */
  items: ITEMS_PROP_TYPE.isRequired,

  /**
   * Array of items in Breakdown (such as subtotal, taxes, fees)
   */
  breakdownItems: BREAKDOWN_ITEMS_PROP_TYPE.isRequired,

  /**
   * Name of the Total
   */
  totalContent: EBPropTypes.translation.isRequired,

  /**
   * Total amount or value
   */
  totalValue: PropTypes.string.isRequired,

  /**
   * Currency type
   */
  currency: PropTypes.string,

  /**
   * Title of the Order Summary
   */
  title: PropTypes.node,

  /**
   * Title of the Breakdown portion of the Order Summary
   */
  breakdownTitle: PropTypes.node,

  /**
   * Message content under Total
   */
  messageContent: PropTypes.string,

  /**
   * Text for top right clickable text
   */
  actionText: PropTypes.node,

  /**
   * Text for bottom right information of the total cost
   */
  totalCostInfo: EBPropTypes.translation,

  /**
   * CTA callback for clickable actionText
   */
  onClickActionText: PropTypes.func
});

export { OrderSummary as default };